<template>
 
       <fragment>             
                               
                                <th>Culturetest</th>
                                <th>Culturedate</th>
                                <th>Cultureres</th>
                            
                              
        </fragment>                     
                    
                  
</template>

<script>



export default {
  name: 'Header',
  data () {
    return {
    }
  },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


    
     
</style>
